import React, { FC } from 'react';

const BlankImage: FC<any> = ({ stroke = '#000' }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4116 15L10.5411 10.9335C10.084 10.2858 9.85539 9.96204 9.57427 9.85289C9.32844 9.75744 9.05485 9.76296 8.81307 9.86825C8.53659 9.98865 8.32127 10.3214 7.89063 10.9869L4.25639 16.6035C4.16099 16.7509 4.11329 16.8247 4.07951 16.9041C4.04952 16.9746 4.02774 17.0483 4.01459 17.1238C3.99977 17.2088 3.99975 17.2967 3.9997 17.4723L3.99902 20H19.9998L19.9998 17.4604C19.9998 17.2891 19.9998 17.2035 19.9857 17.1204C19.9732 17.0467 19.9525 16.9746 19.9239 16.9055C19.8917 16.8276 19.8462 16.7551 19.7551 16.61L18.789 15.0702C17.9352 13.7095 17.5083 13.0291 16.9535 12.7811C16.4685 12.5642 15.9172 12.5492 15.4211 12.7395C14.8537 12.957 14.3905 13.6132 13.4641 14.9256L13.4116 15ZM13.4116 15L16.9535 20M19.9998 6C19.9998 7.10457 19.1044 8 17.9998 8C16.8953 8 15.9998 7.10457 15.9998 6C15.9998 4.89543 16.8953 4 17.9998 4C19.1044 4 19.9998 4.89543 19.9998 6Z"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BlankImage;
